import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { useIntercom } from 'react-use-intercom';
import { Login as LoginModule } from '@dev/ee-modules';
import { ProductCode } from '@dev/ee-api/ee-api-models';

import { useMobile } from '@api/services/hooks/useMobile';
import { LoginUser, SessionFailedAuth, SessionStartAuth, SessionSuccessAuth } from '@api/store/session/actions';
import { ApplicationState as AppState } from '@api/store/index';
import { Resend2FACode, ResendActivationEmail } from '@api/store/auth/actions';
import { LoginWithDisposableToken, ResetAccountEmail } from '@api/store/account/actions';

import { DispatchProps, LoginProps } from './LoginInterface';
import { isIntercomEnabled } from '@api/services/Security';

const dispatchProps = {
    LoginWithDisposableToken,
    SessionStartAuth,
    SessionFailedAuth,
    SessionSuccessAuth,
    Push,
    LoginUser,
    Resend2FACode,
    ResendActivationEmail,
    ResetAccountEmail,
};

const mapState = (state: AppState, ownProps: LoginProps): LoginProps => {
    return {
        ...ownProps,
        account: state.account,
        products: state.products,
        config: state.config,
    };
};

type Props = LoginProps & DispatchProps;

const Login: FC<Props> = ({ LoginWithDisposableToken, ...props }: Props): JSX.Element => {
    const { show } = useIntercom() || {};
    const isMobile = useMobile();
    const launchIntercom = () => {
        isIntercomEnabled() && show();
    };
    const { t } = useTranslation();
    return (
        <LoginModule
            t={t}
            isMobile={isMobile}
            productCode={ProductCode.EmailApi}
            launchIntercom={launchIntercom}
            GOOGLEAPIKEY={GOOGLEAPIKEY}
            {...(props as any)}
        />
    );
};

export default connect<LoginProps, DispatchProps>(mapState, dispatchProps)(Login);
